import Model from './Model';

export default class InvoiceProduct extends Model {
    name;
    default_price;
    vat_percentage;

    static fromJson(json) {
        let instance = super.fromJson(json);

        // Do the required percentages/prices divisions.
        instance.default_price /= 100;
        instance.vat_percentage /= 10;
        return instance;
    }

    toJson() {
        this.default_price *= 100;
        this.vat_percentage *= 10;
        return this;
    }

    static apiPath() {
        return 'invoice-products';
    }
}



// WEBPACK FOOTER //
// ./src/models/InvoiceProduct.js